// Import model
import { FilterCeramicTileCatalogItemRequest } from '../models/FilterCeramicTileCatalogItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CeramicTileCatalogItemCondition } from '../models/CeramicTileCatalogItemCondition';
import { CeramicTileCatalogItemFields } from '../models/CeramicTileCatalogItemFields';
import { CeramicTileCatalogItemIndexedFields } from '../models/CeramicTileCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { CeramicTileCatalogItemConditionSerializer } from './CeramicTileCatalogItemConditionSerializer';
import { CeramicTileCatalogItemFieldsSerializer } from './CeramicTileCatalogItemFieldsSerializer';
import { CeramicTileCatalogItemIndexedFieldsSerializer } from './CeramicTileCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCeramicTileCatalogItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCeramicTileCatalogItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCeramicTileCatalogItemRequest instance
   */
  static deserialize(json: string): FilterCeramicTileCatalogItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCeramicTileCatalogItemRequest instance
   */
  static fromObject(obj: any): FilterCeramicTileCatalogItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCeramicTileCatalogItemRequest');
    }


    const instance: FilterCeramicTileCatalogItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CeramicTileCatalogItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CeramicTileCatalogItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CeramicTileCatalogItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCeramicTileCatalogItemRequest instances
   */
  static deserializeArray(json: string): FilterCeramicTileCatalogItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCeramicTileCatalogItemRequest instance to a JSON string
   */
  static serialize(instance: FilterCeramicTileCatalogItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCeramicTileCatalogItemRequest instance to a plain object
   */
  static toObject(instance: FilterCeramicTileCatalogItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CeramicTileCatalogItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCeramicTileCatalogItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCeramicTileCatalogItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
